
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface PaybackProgressBarProps {
  revenue: number;
  targetRevenue?: number;
}

const PaybackProgressBar: React.FC<PaybackProgressBarProps> = ({ 
  revenue, 
  targetRevenue = 55000 
}) => {
  const percentage = Math.min((revenue / targetRevenue) * 100, 100);
  
  // Определяем цвет на основе процента окупаемости с более яркими цветами
  const getProgressColor = (percent: number) => {
    if (percent < 20) return 'bg-red-600';
    if (percent < 50) return 'bg-orange-500';
    if (percent < 80) return 'bg-yellow-500';
    if (percent < 100) return 'bg-green-500';
    return 'bg-emerald-600';
  };

  return (
    <div className="w-full space-y-1">
      <div className="relative">
        <Progress 
          value={percentage} 
          className="h-3 bg-gray-200 dark:bg-gray-700"
        />
        <div 
          className={`absolute top-0 left-0 h-3 rounded-full transition-all ${getProgressColor(percentage)} shadow-sm`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <div className="text-xs font-semibold text-center">
        {percentage.toFixed(1)}%
      </div>
    </div>
  );
};

export default PaybackProgressBar;
